import {
  SESSION_CREATE,
  SESSION_SAVE,
  PRODUCTS_SAVE,
  SUBSCRIPTION_FETCH,
  SUBSCRIPTION_SAVE,
  SUBSCRIPTION_REQUEST,
  BRANDS_FETCH,
  BRANDS_ADD,
  CURRENT_CARD_BRAND_SAVE,
  LOADING_SHOW,
  LOADING_HIDE,
  MODAL_SHOW,
  MODAL_HIDE,
  FLASH_MESSAGE_SET,
  CARD_UPDATE_REQUEST,
  PRODUCTS_FETCH,
  PRODUCT_UPDATE_REQUEST,
  PIX_SESSION_TOKEN_REQUEST,
} from '../constants/actionTypes';

export const doCreateSession = authCode => ({
  type: SESSION_CREATE,
  authCode,
});

export const doSaveSession = token => ({
  type: SESSION_SAVE,
  token,
});

export const doSaveProducts = products => ({
  type: PRODUCTS_SAVE,
  products,
});

export const doFetchSubscription = () => ({
  type: SUBSCRIPTION_FETCH,
});

export const doSaveSubscription = subscription => ({
  type: SUBSCRIPTION_SAVE,
  subscription,
});

export const doRequestSubscription = payload => ({
  type: SUBSCRIPTION_REQUEST,
  payload,
});

export const doFetchBrands = () => ({
  type: BRANDS_FETCH,
});

export const doSaveBrands = brands => ({
  type: BRANDS_ADD,
  payload: brands,
});

export const doSaveCurrentCardBrand = brand => ({
  type: CURRENT_CARD_BRAND_SAVE,
  payload: brand,
});

export const doRequestUpdateCard = card => ({
  type: CARD_UPDATE_REQUEST,
  card,
});

export const doFetchProducts = () => ({
  type: PRODUCTS_FETCH,
});

export const doRequestUpdateProduct = product => ({
  type: PRODUCT_UPDATE_REQUEST,
  product,
});

export const doSavePixSessionToken = sessionToken => ({
  type: PIX_SESSION_TOKEN_REQUEST,
  sessionToken,
});

/* ----------------- UI ----------------- */

export const doShowLoading = () => ({
  type: LOADING_SHOW,
});

export const doHideLoading = () => ({
  type: LOADING_HIDE,
});

export const doShowModal = target => ({
  type: MODAL_SHOW,
  target,
});

export const doHideModal = () => ({
  type: MODAL_HIDE,
});

export const doSetFlashMessage = payload => ({
  type: FLASH_MESSAGE_SET,
  payload,
});
